import { render, staticRenderFns } from "./ReportSubmit.vue?vue&type=template&id=1b354621&scoped=true"
import script from "./ReportSubmit.vue?vue&type=script&lang=js"
export * from "./ReportSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b354621",
  null
  
)

export default component.exports